stimulusApp.register(
  "cruise-finder",
  class extends Stimulus.Controller {
    static targets = ["changedFilter", "field", "value"]

    #refreshRequest

    connect() {
      this.changedFilterTarget.disabled = true
    }

    disconnect() {
      this.#refreshRequest?.abort()
    }

    toggle(event) {
      event.preventDefault()
      const field = event.currentTarget
      const wasExpanded = field.getAttribute("aria-expanded") === "true"

      this.closeAll()
      if (!wasExpanded) field.setAttribute("aria-expanded", "true")
    }

    select(event) {
      const input = event.currentTarget

      this.#updateSelection(input)
      if (input.name !== "month") {
        this.changedFilterTarget.disabled = false
        this.changedFilterTarget.value = input.name
      }
      this.closeAll()
      this.#focusField(input.dataset.paneKey)
      if (input.name === "month") {
        this.#refreshRequest?.abort()
      } else {
        this.#refresh(input.dataset.paneKey)
      }
    }

    closeOnOutsideClick(event) {
      if (this.element.contains(event.target)) return

      this.closeAll()
    }

    closeAll() {
      this.fieldTargets.forEach((field) =>
        field.setAttribute("aria-expanded", "false"),
      )
    }

    #updateSelection(input) {
      const value = this.valueTargets.find(
        (target) => target.dataset.paneKey === input.dataset.paneKey,
      )
      value.textContent = input.dataset.label
    }

    #focusField(paneKey, form = this.element) {
      form.querySelector(`[name="finder"][value="${paneKey}"]`)?.focus()
    }

    async #refresh(paneKey) {
      this.#refreshRequest?.abort()
      this.#refreshRequest = new AbortController()

      try {
        const query = new FormData(this.element)
        const response = await RailsRequest.get(this.element.action, {
          query,
          signal: this.#refreshRequest.signal,
          responseKind: "html",
        })
        if (!response.ok) return

        const document = new DOMParser().parseFromString(
          await response.html,
          "text/html",
        )
        const finder = document.querySelector("form.cruise-finder")
        if (finder) {
          this.element.replaceWith(finder)
          this.#focusField(paneKey, finder)
        }
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }
  },
)
